export const TrainingOptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 23 15"
      fill="none"
    >
      <path
        d="M5.89087 2.40869H22.5116"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M0.379395 2.40869H3.34106"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M0.379395 7.24463H14.5657"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3875 7.24463H22.5117"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M0.379395 12.5913H7.44372"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.2654 12.5913H22.0832"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M4.75396 3.81749C5.53199 3.81749 6.16271 3.18678 6.16271 2.40875C6.16271 1.63072 5.53199 1 4.75396 1C3.97593 1 3.34521 1.63072 3.34521 2.40875C3.34521 3.18678 3.97593 3.81749 4.75396 3.81749Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.9786 8.65343C16.7566 8.65343 17.3873 8.02271 17.3873 7.24468C17.3873 6.46665 16.7566 5.83594 15.9786 5.83594C15.2005 5.83594 14.5698 6.46665 14.5698 7.24468C14.5698 8.02271 15.2005 8.65343 15.9786 8.65343Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.8565 14.0001C9.63453 14.0001 10.2652 13.3694 10.2652 12.5914C10.2652 11.8133 9.63453 11.1826 8.8565 11.1826C8.07847 11.1826 7.44775 11.8133 7.44775 12.5914C7.44775 13.3694 8.07847 14.0001 8.8565 14.0001Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
